import { api } from "@/http/api-client"
import type { TListInvitesResponse } from "./types"

export function listInvites(organizationSlug: string) {
  return api.get<TListInvitesResponse>(
    `/invites/organization/${organizationSlug}`,
  )
}
